import { compose, Middleware, Dispatch } from "redux";

import ReducerRegistry from "../../lib/ReducerRegistry";

export function createDynamicMiddleware(reducerRegistry: ReducerRegistry) {
  const dynamicMiddleware: Middleware = ({ getState, dispatch }) => next => (action: any) => {
    const middlewareAPI = {
      getState,
      dispatch: (act: any) => dispatch(act),
    };

    const chain = reducerRegistry.getMiddlewares().map(middleware => middleware(middlewareAPI));

    return compose<Dispatch<any>>(...chain)(next)(action);
  };
  return dynamicMiddleware;
}



// WEBPACK FOOTER //
// ./frontend/src/common/middlewares/dynamicMiddleware.ts